import axios from "./axios";
import { parseStrategyReportResponse } from "../pages/StrategyReportPage/strategyReportData";

export const getStrategies = async () => {
  const response = await axios.get("/api/strategy/get-strategies/");
  return response.data;
};

export const getStrategyReport = async (strategyId) => {
  const response = await axios.get(`/api/strategy/get-strategy-report/${strategyId}/`, {
    // Backend returns a JSON string body (not a parsed object).
    transformResponse: [(payload) => payload],
    responseType: "text",
  });
  return parseStrategyReportResponse(response.data);
};
